import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { onboardingService } from '../services/onboarding';

export const onboardingKeys = {
  all: ['onboarding'] as const,
  checklist: () => [...onboardingKeys.all, 'checklist'] as const,
  funnel: () => [...onboardingKeys.all, 'funnel'] as const,
  growth: () => [...onboardingKeys.all, 'growth'] as const,
};

/** The current user's activation checklist (for the dashboard). */
export function useOnboarding() {
  return useQuery({
    queryKey: onboardingKeys.checklist(),
    queryFn: () => onboardingService.get(),
    staleTime: 60 * 1000,
  });
}

/** Platform activation funnel (admin). */
export function useActivationFunnel(enabled: boolean = true) {
  return useQuery({
    queryKey: onboardingKeys.funnel(),
    queryFn: () => onboardingService.getFunnel(),
    enabled,
    staleTime: 60 * 1000,
  });
}

/** Growth scorecard KPIs (admin). */
export function useGrowthScorecard(enabled: boolean = true) {
  return useQuery({
    queryKey: onboardingKeys.growth(),
    queryFn: () => onboardingService.getGrowth(),
    enabled,
    staleTime: 60 * 1000,
  });
}

/** One-click: create + run a starter agent. */
export function useCreateStarterAgent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => onboardingService.createStarter(),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: onboardingKeys.checklist() }),
  });
}
